import { S25Util } from "../../util/s25-util";
import {
    ChangeDetectorRef,
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    ViewChild,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25ChatbotComponent } from "./s25.chat.bot.component";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { S25ModalComponent } from "../s25-modal/s25.modal.component";
import { AiPricingFormulaResponse, Message, S25ChatbotService } from "./s25.chatbot.service";

@TypeManagerDecorator("s25-ng-ai-pricing-formula-chatbot")
@Component({
    selector: "s25-ng-ai-pricing-formula-chatbot",
    template: `
        <s25-ng-ai-chatbot
            #chatbot
            [welcomeMessage]="
                'Provide the details of the pricing for this rate schedule and I will help create the necessary formulas.'
            "
            [mode]="'sidebar'"
            [title]="'AI Pricing Formula Chat'"
            [serviceConfig]="'pricingFormula'"
            (responseReceived)="onResponseReceived($event)"
        ></s25-ng-ai-chatbot>
    `,
    styles: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FormsModule, S25ChatbotComponent],
    standalone: true,
})
export class S25PricingChatbotComponent {
    @ViewChild("chatbot") chatbot!: S25ChatbotComponent<"pricingFormula">;

    formatMessage(response: AiPricingFormulaResponse): string {
        return response.solution
            .map((step, index) => {
                const duration = step.duration_range ? `Duration Range: ${step.duration_range}` : null;
                const time = step.time_range ? `Time Range: ${step.time_range}` : null;
                const formula = `Formula: ${step.formula}`;
                const explanation = `Explanation: ${step.explanation}`;

                const parts = [duration, time, formula, explanation].filter(Boolean);
                return `Formula ${index + 1}:\n${parts.join("\n")}`;
            })
            .join("\n\n");
    }

    async onResponseReceived(response: AiPricingFormulaResponse) {
        this.chatbot.addResponse(this.formatMessage(response));
        response.solution.map((step) => {
            this.chatbot.aiStore.pushAction({ actionType: "pricingFormula", payload: step.formula });
        });
    }
}
